import { gql, useMutation } from '@apollo/client';
import {
  DeleteLivePostMutation,
  DeleteLivePostMutationVariables,
} from '../../../__generated__/queries-web';

const DELETE_LIVE_POST = gql`
  mutation DeleteLivePost($where: LivePostUniqueFilterInput!) {
    deleteLivePost(where: $where) {
      id
    }
  }
`;

export const useLivePostDelete = (livePostId: string) =>
  useMutation<DeleteLivePostMutation, DeleteLivePostMutationVariables>(
    DELETE_LIVE_POST,
    {
      variables: {
        where: {
          id: livePostId,
        },
      },
    },
  );
